import { render, staticRenderFns } from "./plus-in-circles.vue?vue&type=template&id=1aea1012&scoped=true&"
import script from "./plus-in-circles.vue?vue&type=script&lang=js&"
export * from "./plus-in-circles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aea1012",
  null
  
)

export default component.exports